document.addEventListener('DOMContentLoaded', () => {
    const sectionNav = document.querySelector('.site-header__bottom');
    if (!sectionNav) return;

    const positionElementInPage = sectionNav.offsetTop;

    window.addEventListener('scroll', () => {
        if (window.scrollY > positionElementInPage) {
            sectionNav.classList.add('floatable');
        } else {
            sectionNav.classList.remove('floatable');
        }
    });
});
